var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"app"}},[(_vm.isLogged)?_vm._m(0):_vm._e(),_c('v-main',[_c('v-container',{staticClass:"fill-height pa-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"child-flex":""}},[_c('router-view')],1)],1)],1),_c('vue-snotify')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Navbar')
}]

export { render, staticRenderFns }